import API from "./api";

export const getShareholderLetters = async () => {
  const res = await API.get("/shareholder-letters");
  return res.data;
};

export const getShareholderLetterById = async (id) => {
  const res = await API.get(`/shareholder-letters/${id}`);
  return res.data;
};

export const createShareholderLetter = async (data) => {
  const res = await API.post("/shareholder-letters/create", data);
  return res.data;
};

export const updateShareholderLetter = async (id, data) => {
  const res = await API.put(`/shareholder-letters/${id}/update`, data);
  return res.data;
};

export const deleteShareholderLetter = async (id) => {
  const res = await API.delete(`/shareholder-letters/${id}/delete`);
  return res.data;
};

export const getPublicShareholderLetters = async () => {
  const res = await API.get("/public/shareholder-letters");
  return res.data;
};

export const getPublicShareholderLetterByLanguage = async (languageSlug) => {
  const res = await API.get(`/public/shareholder-letters/${languageSlug}`);
  return res.data;
};

export const getNewsroomShareholderLetters = async () => {
  const res = await API.get("/public/newsroom/shareholder-letters");
  return res.data;
};

export const getNewsroomShareholderLetterByLanguage = async (languageSlug) => {
  const res = await API.get(`/public/newsroom/shareholder-letters/${languageSlug}`);
  return res.data;
};

export const translateShareholderLetterContent = async (texts, targetLanguage) => {
  const res = await API.post("/public/shareholder-letters/translate", {
    texts,
    targetLanguage,
  });
  return res.data;
};
